module.exports = __webpack_public_path__ + "img/speaker.bd95cfef.svg";